import React from 'react';
import { IdNamePair } from '../../../modules/dashboard/types';

export interface IRadioButtonEvent {
  name: string;
  value: IdNamePair;
  type: string;
}

export interface IRadioButtonProps {
  options: any;
  action: (params: IRadioButtonEvent) => void;
  checked: any;
  label: string | JSX.Element;
  name: string;
  type?: string;
  color?: 'primary' | 'secondary';
  optionLabel?: string;
  optionValue?: string;
  cy: string;
}

export const RadioButton: React.FC<IRadioButtonProps> = ({
  options,
  action,
  checked,
  label,
  name,
  type = 'radiobutton',
  color = '',
  optionLabel = 'name',
  optionValue = 'id',
  cy = '',
}) => {
  const checkedAction = (e: any) => {
    const resp = e;
    action({ name: name, value: resp, type: type });
  };

  const veryfiChecked = (e: any) => {
    return checked[optionValue] === e[optionValue] ? true : false;
  };

  const capitalizedName = name[0].toUpperCase() + name.substring(1);

  return (
    <div className={`form-box form-radiobutton ${type} ${color} `}>
      <label
        htmlFor={`id-${name}`}
        data-cy={`FormRadiobutton${capitalizedName}${cy}`}
      >
        {label}
      </label>
      <div className="radio-button-container">
        {options
          ? options.map((c: any) => {
              return (
                <div
                  key={`${name}-${c[optionValue]}`}
                  className={`radio-box ${veryfiChecked(c) ? 'checked' : ''}`}
                  onClick={() => checkedAction(c)}
                  data-cy={`FormRadioButton${capitalizedName}OptionClick${c[optionValue]}${cy}`}
                >
                  <span
                    data-cy={`FormRadioButton${capitalizedName}OptionClick${c[optionValue]}${cy}Label`}
                    className={type}
                  ></span>
                  {c[optionLabel]}
                </div>
              );
            })
          : null}
      </div>
    </div>
  );
};
